// src/pages/bond/bond_002_01.jsx
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "react-datepicker/dist/react-datepicker.css";

const Bond002_01 = () => {
  const [loanReceivableId, setLoanReceivableId] = useState(null);

  useEffect(() => {
    // 쿼리 스트링에서 loanReceivableId 가져오기
    const params = new URLSearchParams(window.location.search);
    const id = params.get("loanReceivableId");
    setLoanReceivableId(id);
  }, []);

  if (!loanReceivableId) {
    return <div>Loading...</div>;
  }

  const url = `/bond/detail/loanReceivableId=${loanReceivableId}`;

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        margin: 0,
      }}
    >
      <iframe
        src={url}
        title="Loan Detail"
        style={{ flexGrow: 1, border: "none", width: "100%" }}
      />
      <div
        style={{
          textAlign: "center",
          padding: "10px",
          backgroundColor: "#f1f1f1",
        }}
      >
        <button
          onClick={() => window.close()}
          style={{
            padding: "10px 20px",
            backgroundColor: "green",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

// ReactDOM으로 바로 렌더링 (standalone 용)
// ReactDOM.render(
//   <React.StrictMode>
//     <Bond002_01 />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

export default Bond002_01;
